import * as React from "react"
import * as styles from "./styles.module.scss"
import Period from "./Period"

const CompanyTimeline: React.FC = () => {
  return (
    <section className={styles.companyTimeline}>
      <div className={styles.pagePadding}>
        <div className={styles.container}>
          <div className={styles.header}>
            <h2 className={styles.heading}>Company timeline</h2>
          </div>
          <div className={styles.timeline}>
            <div className={styles.period}>
              <h3 className={styles.year}>2014</h3>
              <div className={styles.tiles}>
                <Period position="left">
                  Founders started a company with the goal of re-engineering the
                  mortgage process.
                </Period>
                <Period position="right">
                  Partnered with Avex Funding, a California originator
                  specializing in prime conforming and jumbo mortgages for over
                  10 years.
                </Period>
              </div>
            </div>
            <div className={styles.period}>
              <h3 className={styles.year}>2015</h3>
              <div className={styles.tiles}>
                <Period position="left">
                  Acquired partner mortgage originator Avex Funding.
                </Period>
                <Period position="right">
                  Developed investor rules engine to algorithmically match
                  borrowers and mortgage products to over 10 large institutional
                  investors.
                </Period>
                <Period position="left">
                  Began working with borrowers directly online without
                  commissioned loan officers.
                </Period>
                <Period position="right">
                  Funded first 100%-digital loan with no borrower phone
                  communication.
                </Period>
              </div>
            </div>

            <div className={styles.period}>
              <h3 className={styles.year}>2016</h3>
              <div className={styles.tiles}>
                <Period position="left">Launched as better.com.</Period>
                <Period position="right">
                  Closed $30 million in Series A funding.
                </Period>
                <Period position="left">
                  Approved as a Fannie Mae seller/servicer and established
                  relationships with 17 top mortgage investors.
                </Period>
              </div>
            </div>
            <div className={styles.period}>
              <h3 className={styles.year}>2017</h3>
              <div className={styles.tiles}>
                <Period position="right">
                  Closed $15 million in Series B funding with Kleiner Perkins
                  Caufield Byers.
                </Period>
                <Period position="left">
                  Introduced the one-day verified pre-approval letter.
                </Period>
              </div>
            </div>
            <div className={styles.period}>
              <h3 className={styles.year}>2018</h3>
              <div className={styles.tiles}>
                <Period position="right">
                  $1 Billion in total funded loans. Thousands of our customers
                  have benefited from our low pricing and great customer
                  service.
                </Period>
              </div>
            </div>
            <div className={styles.period}>
              <h3 className={styles.year}>Today</h3>
              <div className={styles.tiles}>
                <Period position="left" hasButton={true}>
                  You become part of the story by joining thousands of happy
                  Better borrowers.
                </Period>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CompanyTimeline
